import(/* webpackMode: "eager", webpackExports: ["DialogTitle"] */ "/vercel/path0/node_modules/.pnpm/@radix-ui+react-dialog@1.1.15_@types+react-dom@19.2.3_@types+react@19.2.10__@types+reac_243e5081bca3fbc73564cdfd99ffccf4/node_modules/@radix-ui/react-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.8.1_next@15.3.8_@babel+core@7.0.0-beta.56_react-dom@19.2.4_react@19.2.4__re_6999ea75eb2dd4325a5994ed862a72b4/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.0.0-beta.56_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.0.0-beta.56_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/animations/SplitText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/about/Download-resumeBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/about/IntroVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/contact/form/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/experience/ExperienceList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/projects/ProjectCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/Subscription/SubscriptionForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/testimonials/TestimonialDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(home)/testimonials/TestimonialsSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/(layout)/header/HeaderImage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/magicui/box-reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/magicui/highlighter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IconCloud"] */ "/vercel/path0/src/components/magicui/icon-cloud.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WordRotate"] */ "/vercel/path0/src/components/magicui/word-rotate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogContent"] */ "/vercel/path0/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/tour-guide.tsx");
